import axiosInstance from "@/api/axios-instance";
import { DuplicateAccountsResponse } from "@/pages/audit/types/duplicate-accounts";

export interface DuplicateAccountParams {
  page: number;
  limit?: number;
  search?: string;
}

export async function getDuplicateAccounts(
  params: DuplicateAccountParams
): Promise<DuplicateAccountsResponse> {
  const response = await axiosInstance.get("/audit/duplicate-accounts", {
    params,
  });
  return response.data;
}
